import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient defaults for the admin panel.
 * Tuned to reduce refetch noise on CRA navigation while keeping data fresh enough
 * for operational screens (PO listing, vendors, future products/orders).
 */
export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1 * 60 * 1000,
        gcTime: 1 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
        refetchOnMount: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
